import { useForm } from '@inertiajs/react'
import type { FormEvent, ReactNode } from 'react'
import Layout from '../../layouts/Layout'
import Button from '../../components/ui/Button'
import Input from '../../components/ui/Input'
import Card from '../../components/ui/Card'

interface Props {
  errors?: Record<string, string[]>
}

export default function New({ errors: serverErrors }: Props) {
  const { data, setData, post, processing, errors } = useForm({
    user: {
      full_name: '',
      phone_number: '',
      location: '',
      email: '',
    },
  })

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault()
    post('/users')
  }

  const getError = (field: string) => {
    return errors[field as keyof typeof errors] || serverErrors?.[field]?.[0]
  }

  return (
    <Layout title="Sign Up">
      <div className="container mx-auto px-4 py-8 max-w-lg">
        <h1 className="text-3xl font-bold mb-8 text-center">Sign up</h1>

        <Card>
          <form onSubmit={handleSubmit} className="space-y-6">
            <Input
              label="Full Name"
              value={data.user.full_name}
              onChange={(e) => setData('user', { ...data.user, full_name: e.target.value })}
              placeholder="Your Name"
              required
              autoFocus
              error={getError('full_name')}
            />

            <Input
              label="Phone Number"
              value={data.user.phone_number}
              onChange={(e) => setData('user', { ...data.user, phone_number: e.target.value })}
              placeholder="(555) 867-5309"
              required
              error={getError('phone_number')}
            />

            <Input
              label="Location"
              value={data.user.location}
              onChange={(e) => setData('user', { ...data.user, location: e.target.value })}
              placeholder="Place, Earth"
              required
              error={getError('location')}
            />

            <Input
              label="Email"
              type="email"
              value={data.user.email}
              onChange={(e) => setData('user', { ...data.user, email: e.target.value })}
              placeholder="your@email.com"
              required
              error={getError('email')}
            />

            <Button type="submit" disabled={processing} className="w-full">
              {processing ? 'Signing up...' : 'Sign up'}
            </Button>
          </form>
        </Card>

        <p className="mt-6 text-center text-sm text-gray-600">
          Already have an account?{' '}
          <a href="/users/sign_in" className="underline hover:text-black">
            Sign in
          </a>
        </p>
      </div>
    </Layout>
  )
}

New.layout = (page: ReactNode) => page
